export const RISK_COLORS = {
  CRITICAL: 'critical',
  MEDIUM: 'medium',
  DEFAULT: 'default',
} as const;

export type RiskColor = (typeof RISK_COLORS)[keyof typeof RISK_COLORS];

export const TREND_DIRECTIONS = {
  UP: 'up',
  DOWN: 'down',
} as const;

export type TrendDirection =
  (typeof TREND_DIRECTIONS)[keyof typeof TREND_DIRECTIONS];

export const KPI_LAYOUTS = {
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical',
} as const;
export type KPILayout = (typeof KPI_LAYOUTS)[keyof typeof KPI_LAYOUTS];

export interface RiskInfoPart {
  text: string;
  color?: RiskColor;
}
export interface KPICardData {
  value: string;
  label: string;
  trend?: {
    value: string;
    direction: TrendDirection;
    period: string;
  };
  riskInfo?: string | RiskInfoPart[];
}
export interface KPICardsProps {
  cards: KPICardData[];
  layout?: KPILayout;
}
